import KCARESVG1 from '../assets/kcare/Necessary.svg';
import KCARESVG1MOB from '../assets/kcare/mobile.svg';
import KCARESVG2 from '../assets/kcare/Insurance.svg';
import KCARESVG2MOB from '../assets/kcare/mobile_2.svg';
import KCARESVG3MOB from '../assets/kcare/mobile_3.svg';
import KCARESVG3 from '../assets/kcare/Consulate.svg';

export const K_CARE_SECTION = [
    {
        title: `Information to keep you safe.`,
        description: `You'll receive an alert from us if there are any restrictions or local requirements that you should be aware of. You'll also be provided with the necessary tools and information for an enjoyable and safe trip.`,
        svg_desktop: KCARESVG1,
        svg_mobile: KCARESVG1MOB
    },
    {
        title: `Consular Services.`,
        description: `We provide unparalleled support for your travel visa and assist in fulfilling other consulate requirements. Our wide range of assistance in consular and travel regulatory requirements include processing Visa on Arrival, Visa renewal and Extension, Tourist Visas, International passports, Business permits, CERPAC renewals and travels advisory services.`,
        svg_desktop: KCARESVG3,
        svg_mobile: KCARESVG3MOB
    },
    {
        title: `Travel Insurance And Bag Service Offerings`,
        description: `In partnership with our vendors, we give our clients cover for risks associated with travelling within and outside the country. Our travel insurance package meets the need of our clients’ travel needs, whether for leisure, business, multi-country trip cover or medical purpose. We also offer services that assist passengers in locating bags misdirected or mishandled by any airline.`,
        svg_desktop: KCARESVG2,
        svg_mobile: KCARESVG2MOB
    },
]; 